export const translations = {
    de: {
        nav: {
            home: "Startseite",
            about: "Über uns",
            services: "Leistungen",
            gallery: "Galerie",
            pricing: "Preise",
            booking: "Termin",
            contact: "Kontakt",
        },
        hero: {
            eyebrow: "Damensalon · Mannheim",
            title_1: "Frizerka",
            title_2: "Hair by Tijana",
            subtitle: "Schönheit beginnt mit perfektem Haar.",
            cta: "Jetzt Termin buchen",
            secondary: "Leistungen entdecken",
            keune: "Offizieller Keune Partner",
        },
        marquee: ["Balayage", "Keratin", "Styling", "Colour", "Luxury", "Beauty", "Coiffure"],
        about: {
            chapter: "Kapitel 01",
            eyebrow: "Willkommen",
            title: "Willkommen bei Frizerka",
            body_1: "Bei Frizerka – Hair by Tijana stehen Qualität, Stil und individuelle Beratung im Mittelpunkt.",
            body_2: "Wir bieten moderne Damen­haarschnitte, professionelle Colorationen, Balayage, Strähnen, Styling und Haarpflege auf höchstem Niveau — mit Produkten unseres Partners Keune. Ausgewählte Keune-Produkte können Sie direkt bei uns im Salon kaufen.",
            body_3: "Unser Ziel ist es, dass jeder Kunde den Salon glücklich und selbstbewusst verlässt.",
            stats: [
                { n: "10+", l: "Jahre Erfahrung" },
                { n: "100%", l: "Handarbeit" },
            ],
        },
        services: {
            chapter: "Kapitel 02",
            eyebrow: "Leistungen",
            title: "Was wir für Sie tun",
            sub: "Handwerk, Präzision und ein Auge für das Detail — jede Leistung ist auf Ihr Haar zugeschnitten.",
            cats: [
                { title: "Damen", items: ["Waschen", "Schneiden", "Föhnen", "Styling"] },
                { title: "Colorationen", items: ["Balayage", "Ombré", "Highlights", "Ansatzfarbe", "Blondierung"] },
                { title: "Pflege", items: ["Haarmasken", "Keratin", "Intensivpflege"] },
            ],
        },
        gallery: {
            chapter: "Kapitel 03",
            eyebrow: "Portfolio",
            title: "Editorial Gallery",
            sub: "Ein kleiner Auszug aus unserer Handschrift.",
            follow: "Folgen Sie uns auf Instagram",
        },
        pricing: {
            chapter: "Kapitel 05",
            eyebrow: "Preisliste",
            title: "Price list",
            sub: "Qualität, Zeit und Pflege für Ihr Haar — alle Services werden individuell beraten.",
            note: "Hinweis: Alle Farb- und Strähnenservices beinhalten Pflege, Schnitt und Styling. Preise verstehen sich als Gesamtpaket und werden nicht einzeln berechnet.",
            groups: [
                {
                    title: "Schnitt & Styling",
                    items: [
                        { s: "Waschen, Schneiden & Föhnen", p: "ab 45–65 €" },
                        { s: "Trockenschnitt Mädchen", n: "bis 10 Jahre", p: "30 €" },
                        { s: "Waschen & Föhnen", p: "25 €" },
                    ],
                },
                {
                    title: "Farbe / Strähnen",
                    items: [
                        { s: "Ansatzfarbe / Glossing Farbe", n: "inkl. Glossing, Maske, Schnitt, Styling", p: "ab 85 €" },
                        { s: "Ansatzfarbe", n: "ohne Schneiden – kurze Haare, dichtes Haar", p: "65 €" },
                        { s: "Komplettfarbe", p: "ab 95 €" },
                        { s: "Strähnen Glossing", p: "63 €" },
                    ],
                },
                {
                    title: "Aufhellung & Strähnen",
                    items: [
                        { s: "Strähnen", n: "inkl. Glossing, Maske, Schnitt, Styling", p: "ab 155 €" },
                        { s: "Strähnen + Farbe", p: "ab 175 €" },
                        { s: "Ansatz Blondierung", p: "ab 125–165 €" },
                        { s: "Komplettaufhellung", p: "ab 225 €" },
                    ],
                },
                {
                    title: "Keratin Extensions / Bondings",
                    items: [
                        { s: "Keratin Extensions / Bondings – Neuanlage", n: "inkl. Waschen, Schneiden & Stylen", p: "650 € / 100 g" },
                        { s: "Keratin Extensions mit mitgebrachtem Haar", p: "3,50 € / Strähne" },
                        { s: "Entfernen von Keratin Extensions / Bondings", p: "1,00 € / Strähne" },
                    ],
                },
                {
                    title: "Tape-In Extensions",
                    items: [
                        { s: "Tape-In Extensions – Neuanlage", n: "inkl. Waschen, Schneiden & Stylen", p: "ab 450 € / 100 g" },
                        { s: "Tape-In Korrektur", p: "7,20 € / Sandwich" },
                        { s: "Tape-In Extensions mit mitgebrachtem Haar", n: "inkl. Waschen, Schneiden & Stylen", p: "ab 65 € / 25 g" },
                    ],
                },
                {
                    title: "Hochsteckfrisuren",
                    items: [
                        { s: "Hochsteckfrisur 1", p: "35 €" },
                        { s: "Hochsteckfrisur 2", p: "45 €" },
                        { s: "Brautfrisur", p: "ab 65 €" },
                    ],
                },
                {
                    title: "Glättung & Intensivkur",
                    items: [
                        { s: "Keratin Glättung", p: "ab 90–160 €" },
                        { s: "Intensiv Pflege Kur", n: "inkl. Waschen & Föhnen", p: "45 €" },
                        { s: "Intensiv Kur Extra", n: "Zusatz zu einer Dienstleistung", p: "20 €" },
                    ],
                },
            ],
        },
        booking: {
            chapter: "Kapitel 06",
            eyebrow: "Termin",
            title: "Termin buchen",
            sub: "Am schnellsten per WhatsApp — oder senden Sie uns eine Nachricht über das Kontaktformular.",
            whatsapp: "WhatsApp Termin",
            call: "Anrufen",
            form: {
                name: "Name",
                phone: "Telefon",
                email: "E-Mail",
                message: "Nachricht",
                placeholder: "Ihr Wunschtermin, gewünschte Behandlung ...",
                submit: "Anfrage senden",
                sending: "Wird gesendet ...",
                success: "Danke! Wir melden uns in Kürze.",
                error: "Etwas ist schiefgelaufen. Bitte per WhatsApp versuchen.",
            },
        },
        contact: {
            eyebrow: "Kontakt",
            title: "So finden Sie uns",
            hours_title: "Öffnungszeiten",
            days: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
            closed: "Geschlossen",
        },
        mail: {
            title: "Schreiben Sie uns",
            sub: "Ihre Nachricht geht direkt an unser Postfach — wir melden uns so schnell wie möglich.",
            name: "Name",
            email: "E-Mail",
            message: "Nachricht",
            placeholder: "Ihre Nachricht ...",
            submit: "Nachricht senden",
            sending: "Wird gesendet ...",
            success: "Danke! Ihre Nachricht wurde gesendet.",
            error: "Senden fehlgeschlagen. Bitte erneut versuchen.",
        },
        footer: {
            tag: "Damenfriseur in Mannheim.",
            follow: "Folgen",
            contact: "Kontakt",
            hours: "Zeiten",
            rights: "Alle Rechte vorbehalten.",
        },
        misc: {
            book_now: "Termin buchen",
            top: "Nach oben",
        },
    },
    bs: {
        nav: {
            home: "Početna",
            about: "O nama",
            services: "Usluge",
            gallery: "Galerija",
            pricing: "Cjenovnik",
            booking: "Termin",
            contact: "Kontakt",
        },
        hero: {
            eyebrow: "Salon za dame · Mannheim",
            title_1: "Frizerka",
            title_2: "Hair by Tijana",
            subtitle: "Ljepota počinje savršenom kosom.",
            cta: "Zakaži termin",
            secondary: "Pogledaj usluge",
            keune: "Zvanični Keune partner",
        },
        marquee: ["Balayage", "Keratin", "Styling", "Boja", "Luksuz", "Ljepota", "Frizura"],
        about: {
            chapter: "Poglavlje 01",
            eyebrow: "Dobrodošli",
            title: "Dobrodošli u Frizerka",
            body_1: "U salonu Frizerka – Hair by Tijana kvalitet, stil i individualan pristup su na prvom mjestu.",
            body_2: "Nudimo moderno šišanje, profesionalne boje, balayage, pramenove, styling i njegu kose na najvišem nivou — s proizvodima našeg partnera Keune. Odabrane Keune proizvode možete kupiti direktno kod nas u salonu.",
            body_3: "Naš cilj je da svaka klijentkinja izađe iz salona sretna i samouvjerena.",
            stats: [
                { n: "10+", l: "Godina iskustva" },
                { n: "100%", l: "Ručni rad" },
            ],
        },
        services: {
            chapter: "Poglavlje 02",
            eyebrow: "Usluge",
            title: "Šta radimo za vas",
            sub: "Zanat, preciznost i oko za detalj — svaka usluga prilagođena je vašoj kosi.",
            cats: [
                { title: "Dame", items: ["Pranje", "Šišanje", "Fen", "Styling"] },
                { title: "Boje", items: ["Balayage", "Ombré", "Pramenovi", "Farba korijena", "Blajh"] },
                { title: "Njega", items: ["Maske za kosu", "Keratin", "Intenzivna njega"] },
            ],
        },
        gallery: {
            chapter: "Poglavlje 03",
            eyebrow: "Portfolio",
            title: "Editorial Galerija",
            sub: "Mali uvid u naš rukopis.",
            follow: "Pratite nas na Instagramu",
        },
        pricing: {
            chapter: "Poglavlje 05",
            eyebrow: "Cjenovnik",
            title: "Price list",
            sub: "Kvalitet, vrijeme i njega za vašu kosu — svaka usluga uz individualne konsultacije.",
            note: "Napomena: Sve usluge farbanja i pramenova uključuju njegu, šišanje i stiliziranje. Cijene su kompletan paket i ne obračunavaju se pojedinačno.",
            groups: [
                {
                    title: "Šišanje & Stiliziranje",
                    items: [
                        { s: "Pranje, šišanje & fen", p: "od 45–65 €" },
                        { s: "Suvo šišanje za djevojčice", n: "do 10 godina", p: "30 €" },
                        { s: "Pranje & fen", p: "25 €" },
                    ],
                },
                {
                    title: "Boja / Pramenovi",
                    items: [
                        { s: "Boja korijena / Glossing boja", n: "uklj. glossing, maska, šišanje, stiliziranje", p: "od 85 €" },
                        { s: "Boja korijena", n: "bez šišanja – kratka, gusta kosa", p: "65 €" },
                        { s: "Kompletna boja", p: "od 95 €" },
                        { s: "Glossing pramenova", p: "63 €" },
                    ],
                },
                {
                    title: "Blondiranje & Pramenovi",
                    items: [
                        { s: "Pramenovi", n: "uklj. glossing, maska, šišanje, stiliziranje", p: "od 155 €" },
                        { s: "Pramenovi + boja", p: "od 175 €" },
                        { s: "Blondiranje korijena", p: "od 125–165 €" },
                        { s: "Kompletno blondiranje", p: "od 225 €" },
                    ],
                },
                {
                    title: "Keratin Extensions / Bondings",
                    items: [
                        { s: "Keratin Extensions / Bondings – nova postavka", n: "uklj. pranje, šišanje & stiliziranje", p: "650 € / 100 g" },
                        { s: "Keratin Extensions sa donesenom kosom", p: "3,50 € / pramen" },
                        { s: "Uklanjanje Keratin Extensions / Bondings", p: "1,00 € / pramen" },
                    ],
                },
                {
                    title: "Tape-In Extensions",
                    items: [
                        { s: "Tape-In Extensions – nova postavka", n: "uklj. pranje, šišanje & stiliziranje", p: "od 450 € / 100 g" },
                        { s: "Tape-In korekcija", p: "7,20 € / sandwich" },
                        { s: "Tape-In Extensions sa donesenom kosom", n: "uklj. pranje, šišanje & stiliziranje", p: "od 65 € / 25 g" },
                    ],
                },
                {
                    title: "Svečane frizure",
                    items: [
                        { s: "Svečana frizura 1", p: "35 €" },
                        { s: "Svečana frizura 2", p: "45 €" },
                        { s: "Frizura za mladu", p: "od 65 €" },
                    ],
                },
                {
                    title: "Ispravljanje & Intenzivna njega",
                    items: [
                        { s: "Keratin ispravljanje", p: "od 90–160 €" },
                        { s: "Intenzivna njega", n: "uklj. pranje & fen", p: "45 €" },
                        { s: "Intenzivna njega – dodatak", n: "uz drugu uslugu", p: "20 €" },
                    ],
                },
            ],
        },
        booking: {
            chapter: "Poglavlje 06",
            eyebrow: "Termin",
            title: "Zakaži termin",
            sub: "Najbrže putem WhatsApp — ili pošaljite poruku putem formulara.",
            whatsapp: "WhatsApp termin",
            call: "Pozovi",
            form: {
                name: "Ime",
                phone: "Telefon",
                email: "E-Mail",
                message: "Poruka",
                placeholder: "Željeni datum, željena usluga ...",
                submit: "Pošalji upit",
                sending: "Šalje se ...",
                success: "Hvala! Javljamo se uskoro.",
                error: "Nešto nije u redu. Pokušajte putem WhatsApp-a.",
            },
        },
        contact: {
            eyebrow: "Kontakt",
            title: "Kako do nas",
            hours_title: "Radno vrijeme",
            days: ["Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota", "Nedjelja"],
            closed: "Zatvoreno",
        },
        mail: {
            title: "Pišite nam",
            sub: "Vaša poruka stiže direktno u naše poštansko sanduče — javljamo se najbrže što možemo.",
            name: "Ime",
            email: "E-mail",
            message: "Poruka",
            placeholder: "Vaša poruka ...",
            submit: "Pošalji poruku",
            sending: "Šalje se ...",
            success: "Hvala! Vaša poruka je poslana.",
            error: "Slanje nije uspjelo. Pokušajte ponovo.",
        },
        footer: {
            tag: "Frizerski salon u Mannheimu.",
            follow: "Prati",
            contact: "Kontakt",
            hours: "Vrijeme",
            rights: "Sva prava pridržana.",
        },
        misc: {
            book_now: "Zakaži termin",
            top: "Na vrh",
        },
    },
    en: {
        nav: {
            home: "Home",
            about: "About",
            services: "Services",
            gallery: "Gallery",
            pricing: "Pricing",
            booking: "Booking",
            contact: "Contact",
        },
        hero: {
            eyebrow: "Ladies' Salon · Mannheim",
            title_1: "Frizerka",
            title_2: "Hair by Tijana",
            subtitle: "Beauty begins with perfect hair.",
            cta: "Book an appointment",
            secondary: "Explore services",
            keune: "Official Keune Partner",
        },
        marquee: ["Balayage", "Keratin", "Styling", "Colour", "Luxury", "Beauty", "Coiffure"],
        about: {
            chapter: "Chapter 01",
            eyebrow: "Welcome",
            title: "Welcome to Frizerka",
            body_1: "At Frizerka – Hair by Tijana quality, style and personal consultation are at the heart of everything we do.",
            body_2: "We offer modern women's cuts, professional colour, balayage, highlights, styling and hair care at the highest level — with products from our partner Keune. Selected Keune products are available for purchase directly at the salon.",
            body_3: "Our goal: every guest leaves the salon happy and confident.",
            stats: [
                { n: "10+", l: "Years of craft" },
                { n: "100%", l: "Handmade" },
            ],
        },
        services: {
            chapter: "Chapter 02",
            eyebrow: "Services",
            title: "What we do for you",
            sub: "Craft, precision and an eye for detail — every service tailored to your hair.",
            cats: [
                { title: "Ladies", items: ["Wash", "Cut", "Blow-dry", "Styling"] },
                { title: "Colour", items: ["Balayage", "Ombré", "Highlights", "Root touch-up", "Bleach"] },
                { title: "Care", items: ["Hair masks", "Keratin", "Intensive care"] },
            ],
        },
        gallery: {
            chapter: "Chapter 03",
            eyebrow: "Portfolio",
            title: "Editorial Gallery",
            sub: "A small taste of our signature.",
            follow: "Follow us on Instagram",
        },
        pricing: {
            chapter: "Chapter 05",
            eyebrow: "Price list",
            title: "Price list",
            sub: "Quality, time and care for your hair — every service with personal consultation.",
            note: "Note: All colour and highlight services include care, cut and styling. Prices apply as a complete package and are not calculated individually.",
            groups: [
                {
                    title: "Cut & Styling",
                    items: [
                        { s: "Wash, cut & blow-dry", p: "from €45–65" },
                        { s: "Girls' dry cut", n: "up to 10 years", p: "€30" },
                        { s: "Wash & blow-dry", p: "€25" },
                    ],
                },
                {
                    title: "Colour / Highlights",
                    items: [
                        { s: "Root colour / Glossing colour", n: "incl. glossing, mask, cut, styling", p: "from €85" },
                        { s: "Root colour", n: "no cut – short, dense hair", p: "€65" },
                        { s: "Full colour", p: "from €95" },
                        { s: "Highlights glossing", p: "€63" },
                    ],
                },
                {
                    title: "Lightening & Highlights",
                    items: [
                        { s: "Highlights", n: "incl. glossing, mask, cut, styling", p: "from €155" },
                        { s: "Highlights + colour", p: "from €175" },
                        { s: "Root bleach", p: "from €125–165" },
                        { s: "Full lightening", p: "from €225" },
                    ],
                },
                {
                    title: "Keratin extensions / Bondings",
                    items: [
                        { s: "Keratin extensions / Bondings – new application", n: "incl. wash, cut & styling", p: "€650 / 100 g" },
                        { s: "Keratin extensions with your own hair", p: "€3.50 / strand" },
                        { s: "Removal of keratin extensions / Bondings", p: "€1.00 / strand" },
                    ],
                },
                {
                    title: "Tape-In extensions",
                    items: [
                        { s: "Tape-In extensions – new application", n: "incl. wash, cut & styling", p: "from €450 / 100 g" },
                        { s: "Tape-In correction", p: "€7.20 / sandwich" },
                        { s: "Tape-In extensions with your own hair", n: "incl. wash, cut & styling", p: "from €65 / 25 g" },
                    ],
                },
                {
                    title: "Updos & Bridal",
                    items: [
                        { s: "Updo 1", p: "€35" },
                        { s: "Updo 2", p: "€45" },
                        { s: "Bridal hairstyle", p: "from €65" },
                    ],
                },
                {
                    title: "Smoothing & Intensive care",
                    items: [
                        { s: "Keratin smoothing", p: "from €90–160" },
                        { s: "Intensive treatment", n: "incl. wash & blow-dry", p: "€45" },
                        { s: "Intensive add-on", n: "add to another service", p: "€20" },
                    ],
                },
            ],
        },
        booking: {
            chapter: "Chapter 06",
            eyebrow: "Booking",
            title: "Book an appointment",
            sub: "Fastest via WhatsApp — or send us a message through the contact form.",
            whatsapp: "WhatsApp booking",
            call: "Call",
            form: {
                name: "Name",
                phone: "Phone",
                email: "Email",
                message: "Message",
                placeholder: "Preferred date, desired service ...",
                submit: "Send enquiry",
                sending: "Sending ...",
                success: "Thank you! We'll be in touch shortly.",
                error: "Something went wrong. Please try WhatsApp.",
            },
        },
        contact: {
            eyebrow: "Contact",
            title: "How to find us",
            hours_title: "Opening hours",
            days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            closed: "Closed",
        },
        mail: {
            title: "Write to us",
            sub: "Your message goes straight to our inbox — we reply as soon as we can.",
            name: "Name",
            email: "Email",
            message: "Message",
            placeholder: "Your message ...",
            submit: "Send message",
            sending: "Sending ...",
            success: "Thank you! Your message has been sent.",
            error: "Sending failed. Please try again.",
        },
        footer: {
            tag: "Ladies' hair salon in Mannheim.",
            follow: "Follow",
            contact: "Contact",
            hours: "Hours",
            rights: "All rights reserved.",
        },
        misc: {
            book_now: "Book now",
            top: "To top",
        },
    },
    it: {
        nav: {
            home: "Home",
            about: "Chi siamo",
            services: "Servizi",
            gallery: "Galleria",
            pricing: "Listino",
            booking: "Appuntamento",
            contact: "Contatti",
        },
        hero: {
            eyebrow: "Salone da donna · Mannheim",
            title_1: "Frizerka",
            title_2: "Hair by Tijana",
            subtitle: "La bellezza inizia con capelli perfetti.",
            cta: "Prenota un appuntamento",
            secondary: "Scopri i servizi",
            keune: "Partner Keune ufficiale",
        },
        marquee: ["Balayage", "Keratina", "Styling", "Colore", "Lusso", "Bellezza", "Coiffure"],
        about: {
            chapter: "Capitolo 01",
            eyebrow: "Benvenute",
            title: "Benvenute da Frizerka",
            body_1: "Da Frizerka – Hair by Tijana qualità, stile e consulenza personale sono al centro di tutto ciò che facciamo.",
            body_2: "Offriamo tagli donna moderni, colorazioni professionali, balayage, meches, styling e cura dei capelli al più alto livello — con i prodotti del nostro partner Keune. Prodotti Keune selezionati sono disponibili direttamente in salone.",
            body_3: "Il nostro obiettivo: ogni cliente lascia il salone felice e sicura di sé.",
            stats: [
                { n: "10+", l: "Anni di esperienza" },
                { n: "100%", l: "Fatto a mano" },
            ],
        },
        services: {
            chapter: "Capitolo 02",
            eyebrow: "Servizi",
            title: "Ciò che facciamo per te",
            sub: "Artigianato, precisione e occhio al dettaglio — ogni servizio pensato per i tuoi capelli.",
            cats: [
                { title: "Donna", items: ["Lavaggio", "Taglio", "Piega", "Styling"] },
                { title: "Colore", items: ["Balayage", "Ombré", "Meches", "Ritocco radice", "Decolorazione"] },
                { title: "Cura", items: ["Maschere", "Cheratina", "Trattamento intensivo"] },
            ],
        },
        gallery: {
            chapter: "Capitolo 03",
            eyebrow: "Portfolio",
            title: "Galleria editoriale",
            sub: "Un piccolo assaggio della nostra firma.",
            follow: "Seguici su Instagram",
        },
        pricing: {
            chapter: "Capitolo 05",
            eyebrow: "Listino",
            title: "Price list",
            sub: "Qualità, tempo e cura per i tuoi capelli — ogni servizio con consulenza personale.",
            note: "Nota: Tutti i servizi di colore e meches includono cura, taglio e styling. I prezzi si intendono come pacchetto completo e non vengono calcolati singolarmente.",
            groups: [
                {
                    title: "Taglio & Styling",
                    items: [
                        { s: "Lavaggio, taglio & piega", p: "da 45–65 €" },
                        { s: "Taglio bambina a secco", n: "fino a 10 anni", p: "30 €" },
                        { s: "Lavaggio & piega", p: "25 €" },
                    ],
                },
                {
                    title: "Colore / Meches",
                    items: [
                        { s: "Colore radice / Glossing", n: "incl. glossing, maschera, taglio, styling", p: "da 85 €" },
                        { s: "Colore radice", n: "senza taglio – capelli corti, densi", p: "65 €" },
                        { s: "Colore completo", p: "da 95 €" },
                        { s: "Glossing meches", p: "63 €" },
                    ],
                },
                {
                    title: "Decolorazione & Meches",
                    items: [
                        { s: "Meches", n: "incl. glossing, maschera, taglio, styling", p: "da 155 €" },
                        { s: "Meches + colore", p: "da 175 €" },
                        { s: "Decolorazione radice", p: "da 125–165 €" },
                        { s: "Decolorazione completa", p: "da 225 €" },
                    ],
                },
                {
                    title: "Extension cheratina / Bondings",
                    items: [
                        { s: "Extension cheratina / Bondings – nuova applicazione", n: "incl. lavaggio, taglio & styling", p: "650 € / 100 g" },
                        { s: "Extension cheratina con capelli propri", p: "3,50 € / ciocca" },
                        { s: "Rimozione extension cheratina / Bondings", p: "1,00 € / ciocca" },
                    ],
                },
                {
                    title: "Extension Tape-In",
                    items: [
                        { s: "Extension Tape-In – nuova applicazione", n: "incl. lavaggio, taglio & styling", p: "da 450 € / 100 g" },
                        { s: "Correzione Tape-In", p: "7,20 € / sandwich" },
                        { s: "Extension Tape-In con capelli propri", n: "incl. lavaggio, taglio & styling", p: "da 65 € / 25 g" },
                    ],
                },
                {
                    title: "Acconciature & Sposa",
                    items: [
                        { s: "Acconciatura 1", p: "35 €" },
                        { s: "Acconciatura 2", p: "45 €" },
                        { s: "Acconciatura da sposa", p: "da 65 €" },
                    ],
                },
                {
                    title: "Lisciatura & Trattamenti intensivi",
                    items: [
                        { s: "Lisciatura cheratina", p: "da 90–160 €" },
                        { s: "Trattamento intensivo", n: "incl. lavaggio & piega", p: "45 €" },
                        { s: "Trattamento aggiuntivo", n: "da aggiungere a un altro servizio", p: "20 €" },
                    ],
                },
            ],
        },
        booking: {
            chapter: "Capitolo 06",
            eyebrow: "Appuntamento",
            title: "Prenota un appuntamento",
            sub: "Il modo più veloce è via WhatsApp — oppure inviaci un messaggio tramite il modulo.",
            whatsapp: "Appuntamento WhatsApp",
            call: "Chiama",
            form: {
                name: "Nome",
                phone: "Telefono",
                email: "E-mail",
                message: "Messaggio",
                placeholder: "Data desiderata, servizio richiesto ...",
                submit: "Invia richiesta",
                sending: "Invio in corso ...",
                success: "Grazie! Ti risponderemo a breve.",
                error: "Qualcosa è andato storto. Prova via WhatsApp.",
            },
        },
        contact: {
            eyebrow: "Contatti",
            title: "Come raggiungerci",
            hours_title: "Orari di apertura",
            days: ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"],
            closed: "Chiuso",
        },
        mail: {
            title: "Scrivici",
            sub: "Il tuo messaggio arriva direttamente nella nostra casella di posta — rispondiamo il prima possibile.",
            name: "Nome",
            email: "E-mail",
            message: "Messaggio",
            placeholder: "Il tuo messaggio ...",
            submit: "Invia messaggio",
            sending: "Invio in corso ...",
            success: "Grazie! Il tuo messaggio è stato inviato.",
            error: "Invio non riuscito. Riprova.",
        },
        footer: {
            tag: "Salone da donna a Mannheim.",
            follow: "Segui",
            contact: "Contatti",
            hours: "Orari",
            rights: "Tutti i diritti riservati.",
        },
        misc: {
            book_now: "Prenota",
            top: "Torna su",
        },
    },
    fr: {
        nav: {
            home: "Accueil",
            about: "À propos",
            services: "Services",
            gallery: "Galerie",
            pricing: "Tarifs",
            booking: "Rendez-vous",
            contact: "Contact",
        },
        hero: {
            eyebrow: "Salon de coiffure femme · Mannheim",
            title_1: "Frizerka",
            title_2: "Hair by Tijana",
            subtitle: "La beauté commence par des cheveux parfaits.",
            cta: "Prendre rendez-vous",
            secondary: "Découvrir les services",
            keune: "Partenaire officiel Keune",
        },
        marquee: ["Balayage", "Kératine", "Styling", "Couleur", "Luxe", "Beauté", "Coiffure"],
        about: {
            chapter: "Chapitre 01",
            eyebrow: "Bienvenue",
            title: "Bienvenue chez Frizerka",
            body_1: "Chez Frizerka – Hair by Tijana, la qualité, le style et le conseil personnalisé sont au cœur de tout ce que nous faisons.",
            body_2: "Nous proposons des coupes femme modernes, des colorations professionnelles, du balayage, des mèches, du styling et des soins capillaires au plus haut niveau — avec les produits de notre partenaire Keune. Une sélection de produits Keune est disponible à l'achat directement au salon.",
            body_3: "Notre objectif : chaque cliente repart heureuse et confiante.",
            stats: [
                { n: "10+", l: "Années d'expérience" },
                { n: "100%", l: "Fait main" },
            ],
        },
        services: {
            chapter: "Chapitre 02",
            eyebrow: "Services",
            title: "Ce que nous faisons pour vous",
            sub: "Artisanat, précision et sens du détail — chaque prestation adaptée à vos cheveux.",
            cats: [
                { title: "Femme", items: ["Shampooing", "Coupe", "Brushing", "Styling"] },
                { title: "Couleur", items: ["Balayage", "Ombré", "Mèches", "Retouche racines", "Décoloration"] },
                { title: "Soin", items: ["Masques", "Kératine", "Soin intensif"] },
            ],
        },
        gallery: {
            chapter: "Chapitre 03",
            eyebrow: "Portfolio",
            title: "Galerie éditoriale",
            sub: "Un aperçu de notre signature.",
            follow: "Suivez-nous sur Instagram",
        },
        pricing: {
            chapter: "Chapitre 05",
            eyebrow: "Tarifs",
            title: "Price list",
            sub: "Qualité, temps et soin pour vos cheveux — chaque service avec un conseil personnalisé.",
            note: "Note : Tous les services de couleur et de mèches incluent soin, coupe et styling. Les tarifs s'entendent comme un forfait complet et ne sont pas facturés séparément.",
            groups: [
                {
                    title: "Coupe & Styling",
                    items: [
                        { s: "Shampooing, coupe & brushing", p: "à partir de 45–65 €" },
                        { s: "Coupe fille à sec", n: "jusqu'à 10 ans", p: "30 €" },
                        { s: "Shampooing & brushing", p: "25 €" },
                    ],
                },
                {
                    title: "Couleur / Mèches",
                    items: [
                        { s: "Couleur racines / Glossing", n: "incl. glossing, masque, coupe, styling", p: "à partir de 85 €" },
                        { s: "Couleur racines", n: "sans coupe – cheveux courts, denses", p: "65 €" },
                        { s: "Couleur complète", p: "à partir de 95 €" },
                        { s: "Glossing mèches", p: "63 €" },
                    ],
                },
                {
                    title: "Éclaircissement & Mèches",
                    items: [
                        { s: "Mèches", n: "incl. glossing, masque, coupe, styling", p: "à partir de 155 €" },
                        { s: "Mèches + couleur", p: "à partir de 175 €" },
                        { s: "Décoloration racines", p: "à partir de 125–165 €" },
                        { s: "Décoloration complète", p: "à partir de 225 €" },
                    ],
                },
                {
                    title: "Extensions kératine / Bondings",
                    items: [
                        { s: "Extensions kératine / Bondings – nouvelle pose", n: "incl. shampooing, coupe & styling", p: "650 € / 100 g" },
                        { s: "Extensions kératine avec vos cheveux", p: "3,50 € / mèche" },
                        { s: "Retrait extensions kératine / Bondings", p: "1,00 € / mèche" },
                    ],
                },
                {
                    title: "Extensions Tape-In",
                    items: [
                        { s: "Extensions Tape-In – nouvelle pose", n: "incl. shampooing, coupe & styling", p: "à partir de 450 € / 100 g" },
                        { s: "Correction Tape-In", p: "7,20 € / sandwich" },
                        { s: "Extensions Tape-In avec vos cheveux", n: "incl. shampooing, coupe & styling", p: "à partir de 65 € / 25 g" },
                    ],
                },
                {
                    title: "Coiffures & Mariée",
                    items: [
                        { s: "Coiffure 1", p: "35 €" },
                        { s: "Coiffure 2", p: "45 €" },
                        { s: "Coiffure de mariée", p: "à partir de 65 €" },
                    ],
                },
                {
                    title: "Lissage & Soins intensifs",
                    items: [
                        { s: "Lissage kératine", p: "à partir de 90–160 €" },
                        { s: "Soin intensif", n: "incl. shampooing & brushing", p: "45 €" },
                        { s: "Soin complémentaire", n: "à ajouter à une autre prestation", p: "20 €" },
                    ],
                },
            ],
        },
        booking: {
            chapter: "Chapitre 06",
            eyebrow: "Rendez-vous",
            title: "Prendre rendez-vous",
            sub: "Le plus rapide via WhatsApp — ou envoyez-nous un message via le formulaire.",
            whatsapp: "Rendez-vous WhatsApp",
            call: "Appeler",
            form: {
                name: "Nom",
                phone: "Téléphone",
                email: "E-mail",
                message: "Message",
                placeholder: "Date souhaitée, prestation désirée ...",
                submit: "Envoyer la demande",
                sending: "Envoi en cours ...",
                success: "Merci ! Nous vous répondrons rapidement.",
                error: "Une erreur est survenue. Essayez via WhatsApp.",
            },
        },
        contact: {
            eyebrow: "Contact",
            title: "Comment nous trouver",
            hours_title: "Horaires d'ouverture",
            days: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
            closed: "Fermé",
        },
        mail: {
            title: "Écrivez-nous",
            sub: "Votre message arrive directement dans notre boîte mail — nous répondons au plus vite.",
            name: "Nom",
            email: "E-mail",
            message: "Message",
            placeholder: "Votre message ...",
            submit: "Envoyer le message",
            sending: "Envoi en cours ...",
            success: "Merci ! Votre message a été envoyé.",
            error: "Échec de l'envoi. Veuillez réessayer.",
        },
        footer: {
            tag: "Salon de coiffure femme à Mannheim.",
            follow: "Suivre",
            contact: "Contact",
            hours: "Horaires",
            rights: "Tous droits réservés.",
        },
        misc: {
            book_now: "Réserver",
            top: "Haut",
        },
    },
    pl: {
        nav: {
            home: "Strona główna",
            about: "O nas",
            services: "Usługi",
            gallery: "Galeria",
            pricing: "Cennik",
            booking: "Wizyta",
            contact: "Kontakt",
        },
        hero: {
            eyebrow: "Salon damski · Mannheim",
            title_1: "Frizerka",
            title_2: "Hair by Tijana",
            subtitle: "Piękno zaczyna się od idealnych włosów.",
            cta: "Umów wizytę",
            secondary: "Zobacz usługi",
            keune: "Oficjalny partner Keune",
        },
        marquee: ["Balayage", "Keratyna", "Styling", "Kolor", "Luksus", "Piękno", "Fryzura"],
        about: {
            chapter: "Rozdział 01",
            eyebrow: "Witamy",
            title: "Witamy w Frizerka",
            body_1: "W Frizerka – Hair by Tijana jakość, styl i indywidualne doradztwo są w centrum wszystkiego, co robimy.",
            body_2: "Oferujemy nowoczesne strzyżenia damskie, profesjonalne koloryzacje, balayage, pasemka, stylizację i pielęgnację włosów na najwyższym poziomie — z produktami naszego partnera Keune. Wybrane produkty Keune można kupić bezpośrednio w salonie.",
            body_3: "Naszym celem jest, aby każda klientka wychodziła z salonu szczęśliwa i pewna siebie.",
            stats: [
                { n: "10+", l: "Lat doświadczenia" },
                { n: "100%", l: "Ręczna praca" },
            ],
        },
        services: {
            chapter: "Rozdział 02",
            eyebrow: "Usługi",
            title: "Co dla Ciebie robimy",
            sub: "Rzemiosło, precyzja i dbałość o detal — każda usługa dopasowana do Twoich włosów.",
            cats: [
                { title: "Panie", items: ["Mycie", "Strzyżenie", "Suszenie", "Stylizacja"] },
                { title: "Koloryzacja", items: ["Balayage", "Ombré", "Pasemka", "Odrost", "Rozjaśnianie"] },
                { title: "Pielęgnacja", items: ["Maski", "Keratyna", "Intensywna pielęgnacja"] },
            ],
        },
        gallery: {
            chapter: "Rozdział 03",
            eyebrow: "Portfolio",
            title: "Galeria",
            sub: "Mały fragment naszego stylu.",
            follow: "Śledź nas na Instagramie",
        },
        pricing: {
            chapter: "Rozdział 05",
            eyebrow: "Cennik",
            title: "Price list",
            sub: "Jakość, czas i pielęgnacja Twoich włosów — każda usługa z indywidualnymi konsultacjami.",
            note: "Uwaga: Wszystkie usługi koloryzacji i pasemek zawierają pielęgnację, strzyżenie i stylizację. Ceny obowiązują jako kompletny pakiet i nie są liczone osobno.",
            groups: [
                {
                    title: "Strzyżenie & Stylizacja",
                    items: [
                        { s: "Mycie, strzyżenie & suszenie", p: "od 45–65 €" },
                        { s: "Strzyżenie na sucho dziewczęce", n: "do 10 lat", p: "30 €" },
                        { s: "Mycie & suszenie", p: "25 €" },
                    ],
                },
                {
                    title: "Kolor / Pasemka",
                    items: [
                        { s: "Odrost / Glossing kolor", n: "z glossingiem, maską, strzyżeniem, stylizacją", p: "od 85 €" },
                        { s: "Odrost", n: "bez strzyżenia – krótkie, gęste włosy", p: "65 €" },
                        { s: "Pełny kolor", p: "od 95 €" },
                        { s: "Glossing pasemka", p: "63 €" },
                    ],
                },
                {
                    title: "Rozjaśnianie & Pasemka",
                    items: [
                        { s: "Pasemka", n: "z glossingiem, maską, strzyżeniem, stylizacją", p: "od 155 €" },
                        { s: "Pasemka + kolor", p: "od 175 €" },
                        { s: "Rozjaśnianie odrostów", p: "od 125–165 €" },
                        { s: "Pełne rozjaśnianie", p: "od 225 €" },
                    ],
                },
                {
                    title: "Przedłużanie keratynowe / Bondings",
                    items: [
                        { s: "Przedłużanie keratynowe / Bondings – nowa aplikacja", n: "z myciem, strzyżeniem & stylizacją", p: "650 € / 100 g" },
                        { s: "Przedłużanie keratynowe z własnymi włosami", p: "3,50 € / pasmo" },
                        { s: "Zdejmowanie przedłużania keratynowego / Bondings", p: "1,00 € / pasmo" },
                    ],
                },
                {
                    title: "Przedłużanie Tape-In",
                    items: [
                        { s: "Przedłużanie Tape-In – nowa aplikacja", n: "z myciem, strzyżeniem & stylizacją", p: "od 450 € / 100 g" },
                        { s: "Korekta Tape-In", p: "7,20 € / sandwich" },
                        { s: "Przedłużanie Tape-In z własnymi włosami", n: "z myciem, strzyżeniem & stylizacją", p: "od 65 € / 25 g" },
                    ],
                },
                {
                    title: "Upięcia & Ślubne",
                    items: [
                        { s: "Upięcie 1", p: "35 €" },
                        { s: "Upięcie 2", p: "45 €" },
                        { s: "Fryzura ślubna", p: "od 65 €" },
                    ],
                },
                {
                    title: "Prostowanie & Intensywna pielęgnacja",
                    items: [
                        { s: "Prostowanie keratynowe", p: "od 90–160 €" },
                        { s: "Intensywna pielęgnacja", n: "z myciem & suszeniem", p: "45 €" },
                        { s: "Pielęgnacja dodatkowa", n: "dodatek do innej usługi", p: "20 €" },
                    ],
                },
            ],
        },
        booking: {
            chapter: "Rozdział 06",
            eyebrow: "Wizyta",
            title: "Umów wizytę",
            sub: "Najszybciej przez WhatsApp — lub wyślij wiadomość przez formularz.",
            whatsapp: "Wizyta przez WhatsApp",
            call: "Zadzwoń",
            form: {
                name: "Imię",
                phone: "Telefon",
                email: "E-mail",
                message: "Wiadomość",
                placeholder: "Preferowana data, wybrana usługa ...",
                submit: "Wyślij zapytanie",
                sending: "Wysyłanie ...",
                success: "Dziękujemy! Wkrótce się odezwiemy.",
                error: "Coś poszło nie tak. Spróbuj przez WhatsApp.",
            },
        },
        contact: {
            eyebrow: "Kontakt",
            title: "Jak nas znaleźć",
            hours_title: "Godziny otwarcia",
            days: ["Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota", "Niedziela"],
            closed: "Zamknięte",
        },
        mail: {
            title: "Napisz do nas",
            sub: "Twoja wiadomość trafia bezpośrednio do naszej skrzynki — odpowiadamy najszybciej jak to możliwe.",
            name: "Imię",
            email: "E-mail",
            message: "Wiadomość",
            placeholder: "Twoja wiadomość ...",
            submit: "Wyślij wiadomość",
            sending: "Wysyłanie ...",
            success: "Dziękujemy! Twoja wiadomość została wysłana.",
            error: "Wysyłanie nie powiodło się. Spróbuj ponownie.",
        },
        footer: {
            tag: "Salon damski w Mannheim.",
            follow: "Śledź",
            contact: "Kontakt",
            hours: "Godziny",
            rights: "Wszystkie prawa zastrzeżone.",
        },
        misc: {
            book_now: "Umów",
            top: "Do góry",
        },
    },
};

export const LANGUAGES = [
    { code: "de", label: "Deutsch", flag: "🇩🇪" },
    { code: "bs", label: "Bosanski", flag: "🇧🇦", short: "BiH" },
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "it", label: "Italiano", flag: "🇮🇹" },
    { code: "fr", label: "Français", flag: "🇫🇷" },
    { code: "pl", label: "Polski", flag: "🇵🇱" },
];
